import { createFileRoute, redirect } from "@tanstack/react-router";
import { AccreditationDashboard, accreditationDashboardSearch } from "../../components/dashboard/accreditation-dashboard";
import { hasSectorDashboards } from "../../lib/dashboard/sectors";

/** Sector 2 · Dashboard (Approval & Verification for Accreditation): the records and the cards. */
export const Route = createFileRoute("/_app/dashboard/accreditation")({
	beforeLoad: ({ context }) => {
		if (!hasSectorDashboards(context.session)) throw redirect({ to: "/", replace: true });
	},
	validateSearch: accreditationDashboardSearch,
	// Her dashboard runs full width (.pg--dash); see ContentWidth in router.tsx.
	staticData: { contentWidth: "full" },
	component: Page,
});

function Page() {
	const { session } = Route.useRouteContext();
	const search = Route.useSearch();
	const navigate = Route.useNavigate();
	return (
		<AccreditationDashboard
			session={session}
			sector={2}
			search={search}
			onChange={(patch) => navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true })}
		/>
	);
}
